module.exports = __webpack_public_path__ + "media/images/us_flag_small-f01025763b5880c5873885c56c5403fa.png";